export class OrderSummaryResponse{


    sequenceNumber:number
    storeNumber: number;
    poStatus: number;
    status:number;
    cuurentPage: string;
    purchaseOrder: string;
    poCreatedTime: Date;
    poSignedBy: string;
    statusName: string;
    receivedDate: Date;
    
    dcAddress:string;
    dcNumber:number;
    singedTodayByUPN:number;

    ocReceived:string;
}